<!-- Copyright: Seán I. O'Donoghue -->

<template>
  <main class="modal-main">
    <slot />
  </main>
</template>

<style scoped>
.modal-main {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  /* room for a field's 3px focus glow (Form/Wrapper.vue), which overflow-x would clip; the
     negative margin keeps the content where it was (2026-10-14) */
  padding-inline: 4px;
  margin-inline: -4px;
  overscroll-behavior: contain;
  scrollbar-width: thin;
}
</style>
